import { Student } from '../types/Student';

export type StudentsResponse = { data: Student[]; total: number; enrolled_count: number };

export const fetchStudents = async (path: string, token: string, page: number, perPage: number, program?: string) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_BASE_URL}${path}?page=${page}&per_page=${perPage}&program=${program || 'drill_team_2024'}`, {
      headers: {
        Authorization: token,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data: StudentsResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch students:', error);
    return { data: [], total: 0, enrolled_count: 0 };
  }
};

export const fetchEnrolledStudents = async (path: string, token: string, program?: string, page?: number, perPage?: number) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_BASE_URL}${path}?program=${program || 'drill_team_2024'}&page=${page}&per_page=${perPage} `, {
      headers: {
        Authorization: token,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch students:', error);
    // Handle the error appropriately here
    return null; // Returning null to indicate failure in fetch operation
  }
};

export const addStudentToWallOfFame = async (path: string, { arg }: { arg: { studentId: string; topic: string; token: string } }) => {
  const { studentId, token, topic } = arg;
  const response = await fetch(`${import.meta.env.VITE_BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify({ student_id: studentId, topic: topic }),
  });
  return response.json();
};

export const removeStudentFromWallOfFame = async (path: string, { arg }: { arg: { studentId: string; token: string } }) => {
  const { studentId, token } = arg;
  const response = await fetch(`${import.meta.env.VITE_BASE_URL}${path}${studentId}`, {
    method: 'DELETE',
    headers: {
      Authorization: token,
    },
  });
  return response.json();
};
